import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { useTheme } from 'styled-components/native';

import { SVGIconProps } from '../icons.types';

export const BackwardIcon = (props: SVGIconProps) => {
  const { colors } = useTheme();
  const { width = 47, height = 57, fill = colors.text.default } = props;

  return (
    <Svg width={width} height={height} viewBox="0 -960 960 960">
      <Path
        fill={fill}
        fillRule="nonzero"
        d="M480-80q-75 0-140.5-28T225-185q-49-49-77-114.5T120-440h60q0 125 87.321 212.5Q354.643-140 480-140t212.679-87.321Q780-314.643 780-440t-85-212.679Q610-740 485-740h-22l73 73-42 42-147-147 147-147 41 41-78 78h23q75 0 140.5 28T735-695q49 49 77 114.5T840-440q0 75-28 140.5T735-185q-49 49-114.5 77T480-80ZM281-310v-50h121v-55h-82v-50h82v-56H281v-50h127q18.7 0 31.35 12.65Q452-545.7 452-527v173q0 18.7-12.65 31.35Q426.7-310 408-310H281Zm272 0q-18.7 0-31.35-12.65Q509-335.3 509-354v-173q0-18.7 12.65-31.35Q534.3-571 553-571h83q18.7 0 31.35 12.65Q680-545.7 680-527v173q0 18.7-12.65 31.35Q654.7-310 636-310h-83Zm6-50h71v-161h-71v161Z"
      />
    </Svg>
  );
};
